// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"_152fa73","title":"_47bff35","icon":"_63eaea2","iconOpen":"_75fdca7"};